import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';

function StarRating({
  id, name, edit, rating, handleUserInput,
}) {
  return (
    <div key={id} className="star-rating__container">
      <div className="body-text-1 demibold star-rating-category">{name}</div>
      <div className="seller-rating__stars">
        <StarRatings
          rating={rating ? (rating.score || 0) : 0}
          isSelectable={edit}
          starRatedColor="#EDA318"
          starHoverColor="#EDA318"
          starDimension="28px"
          starSpacing="4px"
          changeRating={(e) => {
            if (edit) handleUserInput('ratings', e, id);
          }}
          numberOfStars={5}
          name="rating"
        />
      </div>
    </div>
  );
}

StarRating.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  edit: PropTypes.bool.isRequired,
  rating: PropTypes.shape({}).isRequired,
  handleUserInput: PropTypes.func.isRequired,
};

export default StarRating;
